export default (props, vars) =>
  !props?.['isOutstanding'] || props?.['showLogo'];
